import ApiService from './ApiService'

export const getApiData = data => {
    var datas
    if (data) {
        datas = {
            page: data.pageIndex,
            page_size: data.pageSize,
        }
        data.sort?.map(sort => {
            if (!sort.dir) return sort
            datas.ordering = sort.dir === 'desc' ? `-${sort.column}` : `${sort.column}`
            return sort
        })
        if (data.query) {
            datas.search = data.query
        }
        if (data.selectedTab) {
            datas.is_active = data.selectedTab === 'active'
        }
        if (data?.company) {
            datas.company_code = data?.company
        }
        if (data?.customer) {
            datas.customer_code = data?.customer
        }
        if (data?.checkBox?.length === 1) {
            datas.is_temporary = !data?.checkBox?.includes('register')
        }
        if (data.id) {
            datas.id = data.id
        }
        if (data?.startDate) {
            datas.start_order_date = data?.startDate
        }
        if (data.endDate) {
            datas.end_order_date = data.endDate
        }
        if (data.status) {
            datas.codeDescr = data.status
        }
    }
    return ApiService.get('/api/v1/meson-app/meson-wms-sales-order/', datas)
}
export const createApiRecord = data => ApiService.post('/api/v1/meson-app/meson-wms-sales-order/', data)
export const getApiRecord = id => ApiService.get(`/api/v1/meson-app/meson-wms-sales-order/${id}/`)
export const updateApiRecord = (id, data) => ApiService.put(`/api/v1/meson-app/meson-wms-sales-order/${id}/`, data)
export const deleteApiRecord = id => ApiService.delete(`/api/v1/meson-app/meson-wms-sales-order/${id}/`)

export const getApiDetails = data => ApiService.get(`/api/v1/meson-app/meson-wms-sales-order-dtl/`, data)

export const getApiOrderStatusData = data => ApiService.get('/api/v1/meson-app/meson-wms-sales-order/status-list/', data)
